import { shuffleNewArray } from '../../../../lib/utilityFunctions';
import { CHARACTERS_PER_LEVEL } from '../../constants';

let curriculum = {};
export const setCurriculum = (c) => {
  curriculum = c;
};

export const getCurriculum = () => curriculum;

let audioMap = {};
export const setAudioMap = (a) => { audioMap = a; };
export const getAudioMap = () => audioMap;

const checkBallValidity = (ballToCheck, balls) => {
  if (ballToCheck.similarGraphems) {
    return !balls.some(ball => ballToCheck.similarGraphems.some(questionId => ball.questionId === questionId));
  }
  return true;
};

export const getLevelCount = () => curriculum.levels.length;

export const getBalls = (levelIndex) => {
  const level = levelIndex + 1;
  let balls;
  const newBalls = shuffleNewArray((curriculum.levels.find(item => item.levelId === level).standardItem));
  balls = [];
  for (let i = 0, l = newBalls.length; i < l; i++) {
    // 4 new balls out of the 6 total if level is not 1
    if (level !== 1 && balls.length === 4) {
      break;
    }
    if (checkBallValidity(newBalls[i], balls)) {
      balls = [
        ...balls,
        newBalls[i],
      ];
    }
  }
  if (level !== 1) {
    const oldBalls = shuffleNewArray(curriculum.levels.reduce((prev, item) => {
      if (item.levelId < level) {
        return prev.concat(item.standardItem);
      }
      return prev;
    }, []));
    for (let i = 0, l = oldBalls.length; i < l; i++) {
      if (balls.length === 6) {
        break;
      }
      if (checkBallValidity(oldBalls[i], balls)) {
        balls.push(oldBalls[i]);
      }
    }
  }
  const phonemes = audioMap && audioMap.phoneme;
  balls = balls.map(ball => ({ ...ball, audiofile: phonemes[ball.questionId] }));
  // final shuffle and return
  return shuffleNewArray(balls);
};

// used in shufflePLayerArray because filter function isn't allowed in while-loop
const candidatesForShuffle = (remainingChoices, shuffledArray) => {
  const lastIndex = shuffledArray.length - 1;
  return remainingChoices.filter(({ questionId }) => (
    questionId !== (shuffledArray[lastIndex] || {}).questionId
    && questionId !== (shuffledArray[lastIndex - 1] || {}).questionId
  ));
};

const shufflePlayerArray = (array) => {
  const targetLength = array.length;
  let remainingChoices = [...array];
  let shuffledArray = [];
  while (shuffledArray.length < targetLength) {
    const candidates = candidatesForShuffle(remainingChoices, shuffledArray);
    if (candidates.length === 0) {
      shuffledArray = [];
      remainingChoices = [...array];
    } else {
      const elementToAdd = candidates[Math.floor(Math.random() * candidates.length)];
      shuffledArray.push(elementToAdd);
      remainingChoices.splice(remainingChoices.findIndex(e => e.questionId === elementToAdd.questionId), 1);
    }
  }
  return shuffledArray;
};

export const getPlayers = balls => shufflePlayerArray(balls.reduce((players, ball, id) => [
  ...players,
  {
    ...ball,
    id,
  },
  {
    ...ball,
    id,
  },
  {
    ...ball,
    id,
  },
], [])).slice(0, CHARACTERS_PER_LEVEL);

export const getLevelCurriculum = (level) => {
  const balls = getBalls(level);
  const players = getPlayers(balls);
  return {
    level,
    balls,
    players,
  };
};
